// pages/Dashboard.jsx
import BookWithMe from "../../components/home/orderComponents/BookWithMe";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <BookWithMe />
    </HomeLayout>
  );
}
